<template>
  <div>
    <div
      class="d-flex height-498 bg-cover"
      :style="
        `background-image: url('/wp-content/themes/rhiza/dist/assets/overlay.jpg')`
      "
    ></div>
    <div class="container" v-if="post">
      <div class="row">
        <div class="col-xl-7 bg-white header-materia mb-4 mb-xl-5">
          <div class="row mt-xl-5 mt-4 ml-xl-3 ml-0">
            <h1
              class="font-glacial-bold font-36 ml-xl-3 mt-2"
              v-html="post.title.rendered"
            ></h1>
          </div>
        </div>
      </div>
      <div class="row pb-xl-4 mb-1">
        <div class="col-xl-12 pb-3">
          <div
            class="font-regular font-18 text-xl-left text-center"
            v-html="post.content.rendered"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: null,
  },
  data() {
    return {
      post: null,
    };
  },

  async created() {
    await this.retrievePost();

    if (this.post) {
      var arrTitle = document.title.split("|");
      var [baseTitle] = arrTitle.slice(-1);
      var d = document.createElement("div");
      d.innerHTML = `${this.post.title.rendered} | ${baseTitle}`;
      document.title = d.innerText;
    }
  },

  methods: {
    async retrievePost() {
      var url = `${window.SETTINGS.API_BASE_PATH}posts?_embed&slug=politica-de-privacidade`;

      var response = await axios.get(url);

      this.post = response.data[0];
    },

    dateFormat() {
      if (this.post && this.post.date) {
        return moment(this.post.date)
          .format("DD [de] MMMM [de] YYYY")
          .toUpperCase();
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/politica_privacidade.vue